import { ContentfulLivePreview } from '@contentful/live-preview';

// Helper function to get live update attributes
export function liveUpdateAttrs(entryId?: string, fieldId?: string) {
  if (!entryId || !fieldId) return {};

  return ContentfulLivePreview.getProps({ entryId, fieldId });
}

export function conceptUriToHref(uri: string | undefined): string | undefined {
  if (!uri) return undefined;
  try {
    return new URL(uri).pathname;
  } catch {
    return uri.startsWith('/') ? uri : undefined;
  }
}

export function extractSlugFromUrl(url: string | undefined): string {
  if (!url) return '';

  try {
    const urlObj = new URL(url);
    return (urlObj.pathname + urlObj.search).slice(1);
  } catch {
    return url.startsWith('/') ? url.slice(1) : url;
  }
}
